"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactstrap = require("reactstrap");
var _Spinner = _interopRequireDefault(require("../Spinner"));
require("./index.css");
var _excluded = ["children", "color", "variant", "attachleftbutton", "spinner", "disabled", "className", "style"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function BrtvButton(props) {
  var _classNames;
  var children = props.children,
    color = props.color,
    variant = props.variant,
    _props$attachleftbutt = props.attachleftbutton,
    attachleftbutton = _props$attachleftbutt === void 0 ? false : _props$attachleftbutt,
    _props$spinner = props.spinner,
    spinner = _props$spinner === void 0 ? false : _props$spinner,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    className = props.className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Button, _extends({
    style: attachleftbutton ? _objectSpread({
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }, style) : style,
    className: (0, _classnames["default"])('brtv-btn', (_classNames = {}, _defineProperty(_classNames, "brtv-btn-".concat(color), Boolean(color)), _defineProperty(_classNames, "brtv-btn-".concat(variant), Boolean(variant)), _classNames), className),
    outline: Boolean(variant === 'outline'),
    color: color,
    disabled: spinner || disabled
  }, rest), children, spinner && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: '20px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)));
}
BrtvButton.propTypes = {
  children: _propTypes["default"].string,
  variant: _propTypes["default"].string,
  color: _propTypes["default"].string,
  spinner: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  attachleftbutton: _propTypes["default"].bool
};

// This export will be picked up in ./index.js
var _default = BrtvButton;
exports["default"] = _default;